import { makeTextComponent } from './makeTextComponent'

export const ExternalLink = makeTextComponent(
  'pointer shade-20 underline font-size-large font-family-system font-weight-medium primary'
)
